import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { DOCUMENTS_INFORMATION_API } from "../api";
import {
  setIsNewForDocumentInformation,
  addNewMessage,
  setIsDataChangedForDocuments,
  addErrorMessage,
  addSuccessMessage,
} from "../slice";

export const useDocumentInfo = ({ hasEditAccess }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, isNew, isDataChanged } = useSelector((state) => state.DocumentsInformation);

  const { mutateAsync: addDocumentsInformation } = useMutation((data) =>
    DOCUMENTS_INFORMATION_API.AddDocumentsInformation(data)
  );

  const { mutateAsync: editDocumentsInformation } = useMutation((data) =>
    DOCUMENTS_INFORMATION_API.EditDocumentsInformation(data)
  );

  const handleSubmit = async (route) => {
    if (hasEditAccess && isDataChanged) {
      if (isNew) {
        await addDocumentsInformation(data, {
          onSuccess: ({ data }) => {
            if (data.success) {
              dispatch(setIsNewForDocumentInformation(false));
              dispatch(addSuccessMessage(data?.message));
              navigate(route);
            }
          },
          onSettled: () => {
            dispatch(setIsDataChangedForDocuments(false));
          },
          onError: ({ response }) => {
            dispatch(addErrorMessage(response));
          },
        });
      } else {
        await editDocumentsInformation(data, {
          onSuccess: ({ data }) => {
            if (data.success) {
              dispatch(addSuccessMessage(data?.message));
              navigate(route);
            }
          },
          onSettled: () => {
            dispatch(setIsDataChangedForDocuments(false));
          },
          onError: ({ response }) => {
            dispatch(addErrorMessage(response));
          },
        });
      }
    } else {
      navigate(route);
    }
  };
  return handleSubmit;
};
